import { render, staticRenderFns } from "./test0236.vue?vue&type=template&id=211b7f08&scoped=true"
import script from "./test0236.vue?vue&type=script&lang=js"
export * from "./test0236.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "211b7f08",
  null
  
)

export default component.exports